export const NoImagesDialogEnum = Object.freeze({
  TITLE: 'You have not added any images yet',
  BODY: 'Click the button below to upload images',
  UPLOAD_BUTTON: 'Add Images',
});
